import Nav from "./Nav";
import Footer from "./Footer";
import "./home.css";
import { useNavigate } from "react-router-dom";
import StandardExpressList from "../Components/ListpageExpress";
import { base64backendtoken } from "../HelperFx/datalinks.js";

const REACT_EXPRESS = process.env.REACT_APP_EXPRESS_SERVER;

const SMTPSetup = () => {
  const navigate = useNavigate();

  const columns = [
    {
      name: "Host",
      selector: (row) => (
        <span
          style={{
            color: "blue",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => navigate("/SMTPCard", { state: { id: row.id } })}
        >
          {row.Host || row.host}
        </span>
      ),
      sortable: true,
    },
    { name: "Port", selector: (row) => row.Port || row.port, sortable: true },
    {
      name: "User Name",
      selector: (row) => row.UName || row.uName,
      sortable: true,
    },
    {
      name: "Modified By",
      selector: (row) => row.ModifiedBy || row.modifiedBy || "",
      sortable: true,
    },
  ];

  return (
    <div className="Home">
      <Nav />
      <div className="dash-main settings-full">
        <StandardExpressList
          apiUrl={`${REACT_EXPRESS}/smtp`}
          token={base64backendtoken}
          columns={columns}
          searchKeys={["Host", "UName", "Port", "ModifiedBy"]}
          pageCaption="SMTP Setup"
          actionvisibility
          cardPageLink="SMTPCard"
          redirectTo="UserManagement"
        />
      </div>
      <Footer />
    </div>
  );
};

export default SMTPSetup;
